import { CIMSModule, CIMSPage, Permission } from 'shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'

export function useCAS() {
  return useProtectedMenuItem({
    module: CIMSModule.CAS,
    pages: [
      {
        page: CIMSPage.CASTracker,
        permission: Permission.ViewConstructionAdminSubmittal,
      },
      {
        page: CIMSPage.CASRoutingGroups,
        permission: Permission.ViewCASRoutingGroup,
      },
      {
        page: CIMSPage.CASTypes,
        permission: Permission.ViewCASType,
      },
      {
        page: CIMSPage.CASSubtypes,
        permission: Permission.ViewCASSubtype,
      },
      {
        page: CIMSPage.CASDispositionTypes,
        permission: Permission.ViewCASDispositionType,
      },
      {
        page: CIMSPage.CASQuickLinks,
        permission: Permission.ViewCASQuickLink,
      },
      {
        page: CIMSPage.CASNotifications,
        permission: Permission.ViewCASNotification,
      },
    ],
  })
}
